import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Paper,
  Popper,
  Button,
  Link,
  ClickAwayListener,
} from "@material-ui/core";

import { ReactComponent as PhoneIcon } from "../../../assets/icons/phone.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "auto",
  },
  button: {
    minWidth: "50px",
    padding: theme.spacing(1.25, 1),
  },
  popper: {
    zIndex: theme.zIndex.phoneNumber,
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "1em",
    top: 0,
    left: 0,
    marginTop: "-0.9em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "0 1.5em 1em 1.5em",
      borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
    },
  },
  paper: {
    display: "flex",
    color: theme.palette.text.primary,
    padding: theme.spacing(2.5, 2.75),
    boxShadow: theme.shadows[2],
    borderRadius: theme.shape.borderRadiusSecondary,
  },
  icon: {
    display: "inline-flex",
    marginRight: theme.spacing(1.25),
    paddingTop: theme.spacing(0.25),
    "& svg path": {
      fill: theme.palette.text.primary,
    },
  },
  talkToAnExpert: {
    fontSize: theme.typography.pxToRem(9),
    lineHeight: 1,
    marginBottom: theme.spacing(0.25),
  },
  phoneNumber: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    lineHeight: 1,
    "& a": {
      color: "inherit",
    },
  },
}));

const Phone = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [arrowRef, setArrowRef] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    if (anchorEl) {
      setAnchorEl(null);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-phone-number" : undefined;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={classes.root}>
        <Button
          aria-describedby={id}
          variant="text"
          onClick={handleClick}
          className={classes.button}
        >
          <PhoneIcon width="21" height="21" />
        </Button>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          className={classes.popper}
          modifiers={{
            flip: {
              enabled: true,
            },
            preventOverflow: {
              enabled: true,
            },
            arrow: {
              enabled: true,
              element: arrowRef,
            },
            offset: {
              offset: "-80,6",
            },
          }}
        >
          <div className={classes.arrow} ref={setArrowRef} />
          <Paper className={classes.paper}>
            <div className={classes.icon}>
              <PhoneIcon width="25" height="25" />
            </div>

            <div>
              <Typography className={classes.talkToAnExpert}>
                Sprechen Sie jetzt mit einem Experten:
              </Typography>
              <Typography className={classes.phoneNumber}>
                <Link href="tel:030555786499">030555786499</Link>
              </Typography>
            </div>
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default Phone;
